namespace Matrix.Rebalancer {
    export interface SessionRow {
        SessionId?: string;
        SessionInstanceId?: string;
        BaseCurrency?: string;
        PreparedBy?: string;
        PreparedWhen?: string;
        ApprovedBy?: string;
        ApprovedWhen?: string;
        SessionType?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        BaseCurrencyName?: string;
        BaseCurrencyRowId?: number;
        BaseCurrencyDefaultSortOrder?: number;
    }

    export namespace SessionRow {
        export const idProperty = 'SessionId';
        export const nameProperty = 'SessionId';
        export const localTextPrefix = 'Rebalancer.Session';
        export const lookupKey = 'Rebalancer.Session';

        export function getLookup(): Q.Lookup<SessionRow> {
            return Q.getLookup<SessionRow>('Rebalancer.Session');
        }
        export const deletePermission = 'NoPermission';
        export const insertPermission = 'NoPermission';
        export const readPermission = 'Read:Rebalancer';
        export const updatePermission = 'NoPermission';

        export declare const enum Fields {
            SessionId = "SessionId",
            SessionInstanceId = "SessionInstanceId",
            BaseCurrency = "BaseCurrency",
            PreparedBy = "PreparedBy",
            PreparedWhen = "PreparedWhen",
            ApprovedBy = "ApprovedBy",
            ApprovedWhen = "ApprovedWhen",
            SessionType = "SessionType",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            BaseCurrencyName = "BaseCurrencyName",
            BaseCurrencyRowId = "BaseCurrencyRowId",
            BaseCurrencyDefaultSortOrder = "BaseCurrencyDefaultSortOrder"
        }
    }
}
